module.exports = __webpack_public_path__ + "static/scale-model-of-seattle-aquarium-in-seattle-washington-830dbf1d12060a5bacf4ad9a30b775d3.png";